export default {
  ONLINE: 'online',
  OFFLINE: 'offline',
  PAIRED: 'paired',
};
